// extracted by mini-css-extract-plugin
export var errorsContainer = "_rp-1";
export var link = "_rp-0";